import styled from 'styled-components';
import { GlobalToken } from 'antd';

export const SiteConfigContainer = styled.div<{ token: GlobalToken }>`
    width: 100%;
    padding: ${({ token }) => token.paddingLG}px;
    background: ${({ token }) => token.colorBgContainer};
    border-radius: ${({ token }) => token.borderRadiusSM}px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: ${({ token }) => token.marginLG}px;

    .site-config-title {
        width: 100%;
        color: ${({ token }) => token.colorPrimaryText};
        font-size: ${({ token }) => token.fontSizeHeading4}px;
        font-weight: ${({ token }) => token.fontWeightStrong};
    }

    .site-config-content {
        width: 100%;
    }
    
    .system-controller-input {
        width: 100%;
        box-sizing: border-box;
        background: ${({ token }) => token.colorFillTertiary};
        border-radius: ${({ token }) => token.borderRadiusSM}px;
    }

    .site-config-content {
        width: 100%;

        .config-row {
            width: 100%;
            padding: ${({ token }) => token.padding}px 0;
            border-bottom: 1px solid ${({ token }) => token.colorBorderSecondary};
        }

        .indented-config-row {
            width: 100%;
            border-bottom: none;
        }
    }

    .label-section {
        display: flex;
        align-items: center;
        gap: ${({ token }) => token.marginSM}px;
        
        .avatar {
            background-color: ${({ token }) => token.colorPrimaryBg};
            color: ${({ token }) => token.colorPrimary};
        }

        .label-text {
            font-weight: ${({ token }) => token.fontWeightStrong};
            margin-top: ${({ token }) => token.marginXXS}px;
        }
    }

    .pressure-note-text {
        color: ${({ token }) => token.colorTextSecondary};
        font-size: ${({ token }) => token.fontSizeSM}px;
    }

    .control-section {
        display: flex;
        align-items: center;
        gap: 0;
        flex-wrap: nowrap;
        width: 100%;
        justify-content: flex-start;

        .radio-container {
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: flex-start;
            align-items: center;
        }

            .compact-radio-group {
                flex: 1 1 auto;
                display: flex;
                border-radius: ${({ theme }) => theme.token.borderRadiusLG}px;
            }

                .compact-radio-button {
                    &.active {
                        background: ${({ theme }) => theme.token.colorPrimary};
                    }

                    flex: 1 1 auto;
                    padding: 0 ${({ token }) => token.paddingSM}px;
                    height: 40px;
                    background: ${({ theme }) => theme.token.colorBgContainer};
                    border: 1px solid ${({ theme }) => theme.token.colorBorder};
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    border-radius: ${({ token }) => token.borderRadiusSM}px;
                }
            }
        }

        .fixed-width-radio-group {
            flex: 1 1 auto;
            width: 100%;
            display: flex;
            border-radius: ${({ theme }) => theme.token.borderRadiusLG}px;
        }

        .pressure-radio-button {
            flex: 1 1 auto;
            padding: 0 ${({ token }) => token.paddingLG}px;
            height: 40px;
            background: ${({ token }) => token.colorBgContainer};
            border: 1px solid ${({ token }) => token.colorBorder};
            border-radius: 0;
            color: ${({ token }) => token.colorText};
            display: flex;
            justify-content: center;
            align-items: center;

            &:first-child {
                border-top-left-radius: ${({ token }) => token.borderRadiusSM}px;
                border-bottom-left-radius: ${({ token }) => token.borderRadiusSM}px;
            }

            &:last-child {
                border-top-right-radius: ${({ token }) => token.borderRadiusSM}px;
                border-bottom-right-radius: ${({ token }) => token.borderRadiusSM}px;
            }

            &.active {
                background: ${({ token }) => token.colorPrimary};
                border: 1px solid transparent;
                border-radius: ${({ token }) => token.borderRadiusSM}px
            }
        }

        .other-input {
            margin-left: 0;
            background: ${({ theme: { token } }) => token.colorBgContainer};
            border-radius: ${({ theme }) => theme.token.borderRadiusSM}px;
            box-sizing: border-box;
            outline: 1px solid ${({ theme: { token } }) => token.colorBorder};
            overflow: hidden;
            display: flex;
            justify-content: center;
            align-items: center;

            &::placeholder {
                color: ${({ theme: { token } }) => token.colorPrimary};
            }

            &.active {
                background: ${({ theme: { token } }) => token.colorPrimary};
                outline: 1px solid transparent;
            }

            .input-number-other {
                background: transparent;
                border: none;
                cursor: text;
                text-align: center;
            }
        }

        .station-name-container {
            display: flex;
            align-items: center;
            gap: ${({ token }) => token.marginXS}px;
        }

        .station-name-display {
            color: ${({ token }) => token.colorTextSecondary};
            font-size: ${({ token }) => token.fontSizeSM}px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            flex: 1;
            direction: rtl;
            text-align: right;
        }

        .station-name-text {
            direction: ltr;
            unicode-bidi: embed;
        }

        .station-name-suffix-input {
            min-width: 80px;
            max-width: 120px;
        }
    }
}
`;
